module.exports = "/virtual-football-league/img/amblems/right/Germany/Fake_Hertha.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/Germany/Fake_Hertha.png
// module id = 2140
// module chunks = 4